
import { defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { loadPaginatedECShopCodes } from "@/api/onlineshop";

export default defineComponent({
  name: "shopcodes",
  props: {
    widgetClasses: String,
  },
  data() {
    return {
      list: [],
      loading: true,
    };
  },
  mounted() {
    this.loadPaginatedECShopCodes();
  },
  methods: {
    async loadPaginatedECShopCodes() {
      this.loading = true;
      const response = await loadPaginatedECShopCodes(1);
      this.list = response.data.pageList;
      this.loading = false;
    },
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Online Shop");
    });
  },
});
